<mat-spinner diameter="80" color="#0072C6"></mat-spinner>